import { createApp } from 'vue';
import { GlobalsPlugin } from './vue-globals';
import {
	IEventPayloadRender,
	IEventPayloadRenderCountry,
	IEventPayloadRenderStudy,
	VisaDisplayEvent,
	VisaDisplayReadyEvent,
} from '@studyportals/visa-display-integration';
import App from './presentation/App.vue';
import { GlobalStore } from './store/global';
import { AnonymousStudentPlugin } from './store/global/plugins/AnonymousStudentPlugin';
import { IEventAggregationService } from '@studyportals/student-interfaces';

declare global {
	interface Window {
		EventAggregationService: IEventAggregationService | undefined;
		rollbar: typeof Rollbar;
		rollbarIgnore: (...args: any) => boolean;
	}
}

const mount = (page: string, containerId: string): void => {
	const appProps = {
		page,
	};

	createApp(App, appProps).use(GlobalsPlugin).mount(containerId);
};

const initialize = (event: IEventPayloadRender): void => {
	void GlobalStore.actions.changeDestinationCountry(event.destinationCountryId);

	void new AnonymousStudentPlugin().install();
};

document.addEventListener(VisaDisplayEvent.RENDER_COUNTRY, (evt: unknown) => {
	const event = evt as CustomEvent<IEventPayloadRenderCountry>;

	initialize(event.detail);
	mount('Country', event.detail.rootContainerId);
});

document.addEventListener(VisaDisplayEvent.RENDER_STUDY, (evt: unknown) => {
	const event = evt as CustomEvent<IEventPayloadRenderStudy>;

	initialize(event.detail);
	mount('Study', event.detail.rootContainerId);
});

if (window.EventAggregationService !== undefined) {
	window.EventAggregationService.publishTo(VisaDisplayReadyEvent.EventType, new VisaDisplayReadyEvent());
}
